
define('AwaLabs.ShippingMessage', [
    'ShippingMessage.View',
    'ShippingMessage.Model',
    'CookiesUtilities'
], function ShippingMessage(
    ShippingMessageView,
    Model,
    CookiesUtils
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var placement;
            var childViewVerbose;
            var layout = container.getComponent('Layout');
            var envComponent = container.getComponent('Environment');

            if (envComponent) {
                placement = envComponent.getConfig('shippingMessage.placement');
            }

            if (layout && placement) {
                childViewVerbose = {};
                childViewVerbose[placement] = {
                    'ShippingMessage': {
                        childViewIndex: envComponent.getConfig('shippingMessage.placementIndex') || 0,
                        childViewConstructor: function constructor() {
                            // -------------------------------------------------------------------------------------------------
                            // Section: This will allows us to test using a cookie
                            // If we have a cookie set with a particular zip code, we use it instead of the ip service
                            // -------------------------------------------------------------------------------------------------
                            var testCookie = CookiesUtils.getCookie('testCookie');
                            // -------------------------------------------------------------------------------------------------

                            var model = new Model();

                            if (testCookie) {
                                model.fetch({
                                    data: {
                                        'testCookie': testCookie
                                    }
                                });
                            } else {
                                model.fetch();
                            }
                            return new ShippingMessageView({ container: container, model: model });
                        }
                    }
                };
                layout.addChildViews(layout.DEFAULT_VIEW, childViewVerbose);
            }
        }
    };
});
